import { createSlice } from "@reduxjs/toolkit";

export const appSlice = createSlice({
  name: "app",
  initialState: {
    error: "",
    success: "",
    warning: "",
    drawer: true,
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setWarning: (state, action) => {
      state.warning = action.payload;
    },
    setDrawer: (state, action) => {
      state.drawer = action.payload;
    },
  },
});

export const { setError, setSuccess, setWarning, setDrawer } = appSlice.actions;

export const selectError = (state) => state.app.error;
export const selectSuccess = (state) => state.app.success;
export const selectWarning = (state) => state.app.warning;
export const selectDrawer = (state) => state.app.drawer;

export default appSlice.reducer;
